import { React, useEffect, useState } from "react";
import classes from "./AccessRequest.module.css";
import BackdropComponent from "../Spinner/Spinner";
import CloseIcon from "@mui/icons-material/Close";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

import {
  Grid,
  TextField,
  Modal,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Divider,
  Popper,
  Autocomplete,
  IconButton,
  Button,
  Box,
  Typography,
  styled,
  InputAdornment,
} from "@mui/material";
import { CustomTooltip } from "components/RosterConfig/RosterConfigStyle";
import { GridSearchIcon } from "@mui/x-data-grid";
import { searchEmployeeProfile } from "services/userServices";
import SnackBar from "components/SnackBar/SnackBar";
import InfoModal from "components/CenterPoint/InfoModal/InfoModal";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
import { createAccessRequest, getIdmRitmDetail } from "services/userServices";

const optionTtec = [
  "AgentStateTrackerTool_WFM_Access",
  "WFM_IDM_Group_Admin",
  "AgentStateTrackerTool_TA_Access",
  "AgentStateTrackerTool_OG_Access",
  "AgentStateTrackerTool_OPS_Access",
  "AgentStateTrackerTool_GeneralAccess",
];
const optionPercepta = [
  "AAD-AgentStateTrackerTool_Cloud_WFM_Access",
  "AAD-AgentStateTrackerTool_Cloud_TA_Access",
  "AAD-AgentStateTrackerTool_Cloud_OPS_Access",
  "AAD-AgentStateTrackerTool_Cloud_General_Access",
  "AAD-AgentStateTrackerTool_Cloud_LD_Access",
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "400",
  border: "2px solid #000",
  shadow: "0px 0px 24px rgba(0, 0, 0, 0.5)",
  boxShadow: "0px 0px 24px rgba(0, 0, 0, 0.5)",
  padding: "16px",
  bgcolor: "background.paper",
  maxHeight: "80vh",
  overflow: "auto",
  margin: "auto",
};

const styleTypography = {
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "1rem",
  fontWeight: "600",
  color: "#3F5765",
  letterSpacing: "0.10em",
};

const CustomButton = styled(Button)(() => ({
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  fontSize: "12px",
  letterSpacing: "0.10em",
  borderRadius: "8px",
  fontWeight: "600",
  textTransform: "none",
  color: "white",
  backgroundColor: "#3299FF",
  "&:hover": {
    backgroundColor: "#2878CC",
  },
  float: "right",
}));

export default function AccessRequest(props) {
  const [open, setOpen] = useState(false);
  const { state, handleClose } = props;
  const [loading, setLoading] = useState(false);

  const [requestForOracleId, setRequestForOracleId] = useState(null);
  const [requestForName, setRequestForName] = useState("");
  const [requestForEmail, setRequestForEmail] = useState("");
  const [activeDirectoryGroup, setActiveDirectoryGroup] = useState(null);
  const [aditionalDirectoryGroup, setAditionalDirectoryGroup] = useState(null);

  const [notes, setNotes] = useState("");
  const [userValue, setUserValue] = useState("Ttec");
  const [searchResults, setSearchResults] = useState([]);
  const [searchCriteria, setSearchCriteria] = useState("");
  const [isClicked, setIsClicked] = useState(false);

  const [infoModal, setInfoModal] = useState({
    state: false,
    header: "",
    message: "",
    icon: <CheckCircleSharpIcon sx={{ fontSize: "4rem", color: "green" }} />,
  });

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleInfoClose = () => {
    setInfoModal((prev) => {
      return {
        ...prev,
        state: false,
      };
    });
  };

  const CustomPopper = (props) => {
    return <Popper {...props} placement="bottom-start" />;
  };

  useEffect(() => {
    setOpen(state);
  }, [state]);

  const handleTextAreaChange = (e, setStateMethod) => {
    setStateMethod(e.target.value);
  };

  const resetValues = () => {
    setUserValue("Ttec");
    setNotes("");
    setRequestForName("");
    setRequestForEmail("");
    setRequestForOracleId(null);
    setActiveDirectoryGroup(null);
    setAditionalDirectoryGroup(null);
    handleClose();
    setIsClicked(false);
  };

  const handleValueChange = (name, value) => {
    if (name === "userValue") {
      setUserValue(value);
    } else if (name === "requestForName") {
      setSearchCriteria(value);
    }
  };

  const Save = async () => {
    try {
      setLoading(true);
      setIsClicked(true);
      if (
        requestForName === "" ||
        requestForEmail === "" ||
        requestForOracleId == null
      ) {
        setSnack({
          open: true,
          message: "Requested For field is required!",
          severity: "error",
        });
        return;
      } else if (activeDirectoryGroup === null || activeDirectoryGroup === "") {
        setSnack({
          open: true,
          message: "Active Directory Group field is required!",
          severity: "error",
        });
        return;
      } else if (notes.length < 100) {
        setSnack({
          open: true,
          message: "Business Justification must be at least 100 characters.",
          severity: "error",
        });
        return;
      } else {
        const description =
          notes +
          "\nCould you please add the following user to the Active Directory groups: " +
          `${activeDirectoryGroup}, ${aditionalDirectoryGroup}.` +
          "\nThe user details are as follows: \nOracle ID: " +
          requestForOracleId +
          " \nName: " +
          requestForName +
          " \nEmail: " +
          requestForEmail;

        const createAccessOrderRequest = await createAccessRequest(
          requestForOracleId,
          description
        );

        if (createAccessOrderRequest.status === true) {
          const objReqDetails = JSON.parse(createAccessOrderRequest["data"]);
          const reqSysId = objReqDetails["result"].sys_id;
          const ritmRequest = await getIdmRitmDetail(reqSysId);
          if (ritmRequest.status === true) {
            setInfoModal((prev) => {
              return {
                ...prev,
                state: true,
                message:
                  "Access request created successfully.Here's your ticket number for your reference : " +
                  ritmRequest.data["result"].number,
                header: "Success",
              };
            });
          } else {
            setSnack({
              open: true,
              message: "Something went wrong ! Please try again.",
              severity: "error",
            });
            return;
          }
        } else {
          setSnack({
            open: true,
            message: "Something went wrong ! Please try again.",
            severity: "error",
          });
          return;
        }
        resetValues();
        setIsClicked(false);
      }
    } catch (error) {
      setSnack(true, "Something went wrong !", "error");
    } finally {
      setLoading(false);
      setIsClicked(false);
      resetValues();
    }
  };

  const handleSearch = async (event, searchQuery) => {
    if (searchQuery.length < 3) {
      setSnack({
        open: true,
        message: "Search criteria must be at least 3 characters in length.",
        severity: "error",
      });
      return;
    }

    const searchResult = await searchEmployeeProfile(searchQuery);
    if (searchResult.status === true) {
      let searchResultDetails;

      if (/^\d+$/.test(searchQuery) && searchQuery.length >= 4) {
        searchResultDetails = searchResult.data.map((emp) => ({
          OracleId: emp.OracleId,
          Display:
            (emp.Name ?? "") + (emp.OracleId ? ` (${emp.OracleId})` : ""),
          Name: emp.Name,
          Email: emp.Email,
        }));
      } else {
        searchResultDetails = searchResult.data.map((emp) => ({
          OracleId: emp.OracleId,
          Display: emp.Display,
          Name: emp.Name,
          Email: emp.Email,
        }));
      }

      setSearchResults(searchResultDetails);

      setSnack({
        open: true,
        message: "We found results matching the search criteria.",
        severity: "success",
      });
    } else {
      setSnack({
        open: true,
        message: "No result found matching with search criateria.",
        severity: "error",
      });
    }
  };

  const handleInputChange = (event, newInputValue) => {
    if (newInputValue === "") {
      setRequestForOracleId(null);
      setRequestForName("");
      setRequestForEmail("");
    }
  };

  const handleSelectionChange = (event, value) => {
    if (value) {
      setRequestForOracleId(value.OracleId);
      setRequestForName(value.Name);
      setRequestForEmail(value.Email);
    }
    setSearchResults([]);
  };

  const handleAutocompleteChange = (value) => {
    setActiveDirectoryGroup(value);
    if (
      value === "AgentStateTrackerTool_OG_Access" ||
      value === "AgentStateTrackerTool_TA_Access" ||
      value === "AAD-AgentStateTrackerTool_Cloud_TA_Access"
    ) {
      setAditionalDirectoryGroup("ASTTAgentDetailsAccess_Med");
    } else {
      setAditionalDirectoryGroup("ASTTAgentDetailsAccess_Low");
    }
  };
  return (
    <>
      {loading ? <BackdropComponent /> : null}
      <InfoModal
        open={infoModal.state}
        message={infoModal.message}
        header={infoModal.header}
        icon={infoModal.icon}
        handleClose={handleInfoClose}
      />
      <Modal
        open={open}
        onClose={() => {
          resetValues();
        }}
      >
        <Box sx={{ ...style }}>
          <Grid item xs={12}>
            <Typography
              sx={{
                fontFamily: "Urbanist, Verdana, Arial, sans-serif",
                fontSize: 18,
                fontWeight: "bold",
                color: "#3F5765",
                letterSpacing: "0.10em",
              }}
            >
              <SupportAgentIcon sx={{ fontSize: 26, marginRight: 1 }} />
              Access Request
              <CloseIcon
                sx={{
                  fontSize: 24,
                  cursor: "pointer",
                  color: "#3F5765",
                  "&:hover": { color: "#d32f2f" },
                  float: "right",
                }}
                onClick={() => {
                  resetValues();
                }}
              />
            </Typography>
          </Grid>
          <Grid container spacing={2} padding={2}>
            <Grid item xs={4}>
              <Typography sx={{ ...styleTypography }}>User Name</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography sx={{ ...styleTypography }}>
                User Oracle ID
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography sx={{ ...styleTypography }}>User Email</Typography>
            </Grid>
            <Grid item xs={4}>
              <p>{localStorage.getItem("User")}</p>
            </Grid>
            <Grid item xs={4}>
              <p>{localStorage.getItem("OracleId")}</p>
            </Grid>
            <Grid item xs={4}>
              <p>{localStorage.getItem("EmailId")}</p>
            </Grid>
          </Grid>
          <Divider
            sx={{
              fontFamily: "Urbanist, Verdana, Arial, sans-serif",
              fontSize: "1rem",
              fontWeight: "600",
              color: "#3F5765",
              letterSpacing: "0.10em",
              px: 3,
            }}
          >
            Requested For
          </Divider>
          <Grid container spacing={2} padding={3}>
            <Grid item xs={6}>
              <Autocomplete
                freeSolo
                options={searchResults}
                onInputChange={handleInputChange}
                onChange={handleSelectionChange}
                PopperComponent={CustomPopper}
                getOptionLabel={(option) => option.Display || ""}
                renderInput={(params) => (
                  <TextField
                    name="requestForName"
                    {...params}
                    size="small"
                    placeholder="Search by Oracle ID or Name or Email"
                    value={requestForName || ""}
                    onChange={(event) =>
                      handleValueChange(event.target.name, event.target.value)
                    }
                    sx={{ minWidth: 120 }}
                    InputProps={{
                      maxLength: 50,
                      ...params.InputProps,
                      endAdornment: (
                        <InputAdornment position="end">
                          <CustomTooltip title="Search">
                            <IconButton
                              id="icon-button-search"
                              type="button"
                              onClick={(event) =>
                                handleSearch(event, searchCriteria)
                              }
                            >
                              <GridSearchIcon />
                            </IconButton>
                          </CustomTooltip>
                          {params.InputProps.endAdornment}
                        </InputAdornment>
                      ),
                    }}
                    label={
                      <Box component={"span"}>
                        Requested For
                        <Box component={"span"} sx={{ color: "red" }}>
                          *
                        </Box>
                      </Box>
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                fullWidth
                name="ogEmail"
                value={requestForEmail || ""}
                size="small"
                placeholder="Email"
                InputProps={{ readOnly: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <FormControl>
                <FormLabel component="legend"> Choose Login Option</FormLabel>
                <RadioGroup
                  name="userValue"
                  row
                  value={userValue}
                  onChange={(e) =>
                    handleValueChange(e.target.name, e.target.value)
                  }
                >
                  <FormControlLabel
                    value={"Ttec"}
                    control={<Radio />}
                    label="@ttec.com users"
                  />
                  <FormControlLabel
                    value={"Percepta"}
                    control={<Radio />}
                    label="@percepta.com users"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                disablePortal
                freeSolo
                openOnFocus
                options={userValue === "Ttec" ? optionTtec : optionPercepta}
                value={activeDirectoryGroup}
                onChange={(e, value) => handleAutocompleteChange(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Active Directory Group"
                    label={
                      <span>
                        Active Directory Group
                        <Box component={"span"} sx={{ color: "red" }}>
                          *
                        </Box>
                      </span>
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                name="Business Justification"
                value={notes}
                rows={4}
                label="Business Justification"
                placeholder="Business Justification (Minimum 100 and Max 2000 characters allowed)"
                helperText={`${notes ? notes.length : 0}/${2000}`}
                inputProps={{ minLenght: 100, maxLength: 2000 }}
                onChange={(event) => handleTextAreaChange(event, setNotes)}
                FormHelperTextProps={{
                  sx: {
                    position: "absolute",
                    bottom: 8,
                    right: 8,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomButton
                variant="contained"
                onClick={Save}
                disabled={notes.length < 100 || isClicked}
              >
                Submit
              </CustomButton>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <SnackBar snack={snack} snackReset={snackReset} />
    </>
  );
}
